/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request of POST /prtimes_media_lists/{media_list_id}/selected_media_lists/logs
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogRecordRequest
 */
export interface PrtimesMediaListsSelectedMediaListsLogRecordRequest {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordRequest
     */
    mediaListName: string;
    /**
     * 送信者名
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordRequest
     */
    senderName: string;
    /**
     * メディアのIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordRequest
     */
    mediaOutletIds: Array<number>;
}

export function PrtimesMediaListsSelectedMediaListsLogRecordRequestFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogRecordRequest {
    return PrtimesMediaListsSelectedMediaListsLogRecordRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogRecordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': json['media_list_name'],
        'senderName': json['sender_name'],
        'mediaOutletIds': json['media_outlet_ids'],
    };
}

export function PrtimesMediaListsSelectedMediaListsLogRecordRequestToJSON(value?: PrtimesMediaListsSelectedMediaListsLogRecordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
        'media_outlet_ids': value.mediaOutletIds,
    };
}

